module.exports = __webpack_public_path__ + "prod/1.2.3/img/alipay.642133f6.svg";